export const popoverLocale = {
    closeLabel: 'Close',
};
//# sourceMappingURL=Popover.locale.js.map